module.exports = __webpack_public_path__ + "components/flag/static/square/si-b7ef0bee7cc0168826e68202eea23ccb.svg";